import ImageCarousel from '../components/ImageCarousel/ImageCarousel';
import LazyImage from '../components/LazyImage/LazyImage';
import PageHeaderApp from '../components/PageHeader/PageHeaderApp';
import ScrollAnimations from '../components/ScrollAnimations/ScrollAnimations';
import Video from '../components/Video/Video';

export function loadComponents() {
  ImageCarousel();
  LazyImage();
  Video();
  PageHeaderApp();

  ScrollAnimations.enable();
}

export default loadComponents;
